/** @file English catalog: the source of truth; every key must exist here (other languages are partial). */
import { autorigPanelEn } from './en/autorigPanelEn.data';
import { curvesEn } from './en/curvesEn.data';
import { docPanelsEn } from './en/docPanelsEn.data';
import { formsEn } from './en/formsEn.data';
import { liveEn } from './en/liveEn.data';
import { meshToolsEn } from './en/meshToolsEn.data';
import { projectsExtraEn } from './en/projectsExtraEn.data';
import { rigPanelsEn } from './en/rigPanelsEn.data';
import { settingsExtraEn } from './en/settingsExtraEn.data';
import { settingsScreenEn } from './en/settingsScreenEn.data';
import { timelineEn } from './en/timelineEn.data';
import { toolsEn } from './en/toolsEn.data';
import { viewportEn } from './en/viewportEn.data';
import { weightsEn } from './en/weightsEn.data';

/**
 * Composed once from the per-area parts under `catalogs/en/` (W3-03): each Wave-3 editor area owns one part and
 * replaces it whole; nobody edits this file. The spread points below are fixed.
 */
export const en = {
  app: { title: 'Pose2D' },
  settings: {
    title: 'Settings',
    language: 'Interface language',
    languageName: 'English',
    languageHint: 'Names of bones, slots and animations stay in English.',
    shortcuts: 'Keyboard shortcuts',
    theme: 'Theme',
    themeDark: 'Dark',
    resetLayout: 'Reset panel layout',
    ...settingsExtraEn,
  },
  common: { save: 'Save', cancel: 'Cancel', delete: 'Delete', undo: 'Undo', redo: 'Redo' },
  messages: { renamedLayers: 'Renamed {n} layers to ASCII names', renamedUnique: 'Renamed {n} layers whose names were already in use: a number was added to each' },
  shell: { projects: 'Projects', settings: 'Settings', signOut: 'Sign out', loading: 'Loading…', notFound: 'This page does not exist.', retry: 'Try again' },
  login: { title: 'Sign in to Pose2D', username: 'Username', password: 'Password', submit: 'Sign in' },
  projects: {
    title: 'Projects', search: 'Search projects', sort: 'Sort by', sortUpdated: 'Recently updated', sortName: 'Name',
    showTrash: 'Show trash', showActive: 'Show projects', newName: 'New project name', create: 'Create',
    trash: 'Move to trash', empty: 'No projects here yet.', meta: 'rev {rev} · {actor} · {date}',
    ...projectsExtraEn,
  },
  panels: {
    placeholder: 'This panel arrives in a later wave.',
    viewport: { title: 'Viewport' },
    ...docPanelsEn,
    ...timelineEn,
    ...weightsEn,
    ...rigPanelsEn,
  },
  viewport: viewportEn,
  tools: { ...toolsEn, ...meshToolsEn },
  forms: formsEn,
  curves: curvesEn,
  ...settingsScreenEn,
  ...liveEn,
  ...autorigPanelEn,
  errors: {
    unauthorized: 'Wrong username or password.', rateLimited: 'Too many attempts; try again in {seconds} s.',
    nameTaken: 'The name "{name}" is already used.', invalidName: '"{name}" is not a valid name: use ASCII letters, digits, - and _.',
    notFound: 'Not found: {ref}', generic: 'Something went wrong: {message}', crashed: 'This view crashed.',
  },
} as const;
